import { Account, TimeTrackerProvider } from "@/views";
import axios from "axios";

const baseUrl: string = "/api/v0/account"

export interface CreateAccountModel {
    name: string;
    apiKey: string;
    provider: TimeTrackerProvider;
    providerUrl: string | null;
}

export interface AccountTimerState {
    id: string;
    uploaded: boolean;
}

const accountApi = {
    getAccounts: async (): Promise<Account[]> => {
        const { data } = await axios.get<Account[]>(baseUrl);
        return data;
    },

    createAccount: async (model: CreateAccountModel): Promise<string> => {
        const { data } = await axios.post<string>(baseUrl, model);
        return data;
    },

    deleteAccount: async (accountId: string): Promise<void> => {
        await axios.delete(`${baseUrl}/${accountId}`);
    },

    timerStatus: async (accountIds: string[]): Promise<AccountTimerState[]> => {
        const { data } = await axios.post<AccountTimerState[]>(`${baseUrl}/timerstatus`, accountIds);
        return data;
    },

    uploadIif: async (accountId: string, file: File): Promise<void> => {
        const formData = new FormData();
        formData.append("iif-file", file);
        await axios.post(
            `${baseUrl}/${accountId}/uploadiif`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
    },
};

export type AccountApi = typeof accountApi;

export default accountApi;
